import ExerciserResultsCardHeader from "../../../others/courses/exercisers/ExerciserResultsCardHeader";
import ExerciserResultsCardHeaderDivider from "../../../dividers/courses/exercisers/ExerciserResultsCardHeaderDivider";
import ExerciserResultsQuestionsList from "../../../lists/courses/exercisers/ExerciserResultsQuestionsList";

export default function ExerciserResultsDesktopQuestionsCard({levelA, questions}) {
    // Used in FlashResultsScreen to display Questions List Card
    // in desktop mode

    // BUILD
    return (
        <div className={"overflow-auto bg-backgroundLight5 hidden h-[544px] min-h-[544px] max-h-[544px] w-[536px] max-w-[536px] lg:flex lg:flex-col shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px]"}>
            {/** CORE */}
            <ExerciserResultsCardHeader headerTitle={`Liste des questions (${questions?.length})`} />
            <ExerciserResultsCardHeaderDivider />
            <div className={"overflow-auto bg-backgroundLight5 w-full grow shadow-[inset_0px_0px_2px_rgba(82,96,120,1)]"}>
                <ExerciserResultsQuestionsList levelA={levelA}
                                               questions={questions} />
            </div>
        </div>
    );
}